import {DatePeriodEnum} from '../../../../../../util/date';

export const ratingHistoryAllowedDateAggregations: Array<DatePeriodEnum> = [
    DatePeriodEnum.Week,
    DatePeriodEnum.Month,
    DatePeriodEnum.PreviousFullMonth,
    DatePeriodEnum.Quarter,
];
